/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MonthByMonthDownload_viewer$ref: FragmentReference;
declare export opaque type MonthByMonthDownload_viewer$fragmentType: MonthByMonthDownload_viewer$ref;
export type MonthByMonthDownload_viewer = {|
  +company: ?{|
    +resourceBasedPersons: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +firstName: ?string,
          +lastName: ?string,
          +profilePictureId: ?string,
          +aggregatedResourceNumbers: $ReadOnlyArray<?string>,
        |}
      |}>
    |}
  |},
  +$refType: MonthByMonthDownload_viewer$ref,
|};
export type MonthByMonthDownload_viewer$data = MonthByMonthDownload_viewer;
export type MonthByMonthDownload_viewer$key = {
  +$data?: MonthByMonthDownload_viewer$data,
  +$fragmentRefs: MonthByMonthDownload_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery",
      "type": "TaskSearchQueryType"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageSize",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MonthByMonthDownload_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "after",
              "variableName": "cursor"
            },
            {
              "kind": "Literal",
              "name": "aggregateLevel",
              "value": "MONTH"
            },
            {
              "kind": "Literal",
              "name": "aggregates",
              "value": [
                "forecastBillableUtilization",
                "forecastBillableUtilizationWin",
                "forecastBillableUtilizationSoft",
                "forecastBillableUtilizationSoftWin",
                "forecastBillableUtilizationHard",
                "forecastResourceUtilization",
                "forecastResourceUtilizationWin",
                "forecastResourceUtilizationSoft",
                "forecastResourceUtilizationSoftWin",
                "forecastResourceUtilizationHard",
                "forecastBillableUtilizationTaskAndAllocationsCombined",
                "forecastBillableUtilizationTaskAndAllocationsCombinedWin",
                "forecastBillableUtilizationTaskAndAllocationsCombinedSoft",
                "forecastBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                "forecastBillableUtilizationTaskAndAllocationsCombinedHard",
                "forecastResourceUtilizationTaskAndAllocationsCombined",
                "forecastResourceUtilizationTaskAndAllocationsCombinedWin",
                "forecastResourceUtilizationTaskAndAllocationsCombinedSoft",
                "forecastResourceUtilizationTaskAndAllocationsCombinedSoftWin",
                "forecastResourceUtilizationTaskAndAllocationsCombinedHard"
              ]
            },
            {
              "kind": "Variable",
              "name": "endDay",
              "variableName": "endDay"
            },
            {
              "kind": "Variable",
              "name": "endMonth",
              "variableName": "endMonth"
            },
            {
              "kind": "Variable",
              "name": "endYear",
              "variableName": "endYear"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "pageSize"
            },
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "searchQuery"
            },
            {
              "kind": "Variable",
              "name": "startDay",
              "variableName": "startDay"
            },
            {
              "kind": "Variable",
              "name": "startMonth",
              "variableName": "startMonth"
            },
            {
              "kind": "Variable",
              "name": "startYear",
              "variableName": "startYear"
            }
          ],
          "concreteType": "PersonTypeConnection",
          "kind": "LinkedField",
          "name": "resourceBasedPersons",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profilePictureId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "aggregatedResourceNumbers",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = 'ddecb09edbbe78c3fec9d668010b0f28';

module.exports = node;
